define("shared/utils/number-helpers/ratio-to-percent", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * @module Utils
   */

  /**
   * @class ratioToPercent
   * @extends Utils
   */

  /**
   * Returns the percentage for the given ratio.
   *
   * @method ratioToPercent
   * @param {Number} ratio Ratio to be converted to a percentage.
   *
   * @returns {Number} Percentage
   */
  const ratioToPercent = function () {
    let ratio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return ratio * 100;
  };
  var _default = _exports.default = ratioToPercent;
});